export const loadCosmosAlert = async (): Promise<void> => {
  await import(/* webpackChunkName: "cosmos_alert" */ 'cookie-banner/styles/cosmos-global')
}

export const loadCosmosModal = async (): Promise<void> => {
  await import(/* webpackChunkName: "cosmos_modal" */ 'cookie-banner/styles/cosmos-configure-modal-style')
}
